import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <div className="max-w-md w-full text-center rounded-2xl border border-slate-700 bg-slate-900 p-10 shadow-2xl" data-testid="payment-cancel">
        <XCircle className="h-14 w-14 text-slate-400 mx-auto" />
        <h1 className="text-2xl font-bold text-white mt-6">Checkout canceled</h1>
        <p className="text-slate-400 mt-2">No charge was made. You can start your free trial anytime.</p>
        <Button onClick={() => navigate('/')} className="mt-6 bg-amber-400 text-slate-900 font-bold hover:bg-amber-500">
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default PaymentCancel;
